import { IBookmarks } from "../../services/cayuga/types";
import { CameraDataInterface } from "../cameras/types";
import {
  BwsAddCameraBookmarksAction,
  BwsAddTimeStripsAction,
  BwsErrorTimeStripsAction,
  BwsResetTimeStripsAction,
  BwsTimestripIsFetchingAction,
  ErrorBrowsePaneAction,
  FetchBrowsePaneAction,
  getStreamType,
  InitBrowsePaneAction,
  ResetBrowsePanesAction,
  SetDraggableCamIdAction,
  SetSelectedBookmarkAction,
  StartBrowsePaneAction,
  SuccessBrowsePaneAction
} from "./types";

//////////////////////////////////////////////////////////////////////////////////////////////
export const startBrowsePane = ({pane, width, height, camId, streamId}: getStreamType): StartBrowsePaneAction =>
  ({type: 'startBrowsePane', pane, width, height, camId, streamId});

export const initBrowsePane = (pane: number, id: string): InitBrowsePaneAction => ({type: 'initBrowsePane', pane, id});

export const errorBrowsePane = (pane: number): ErrorBrowsePaneAction => ({type: 'errorBrowsePane', pane});

export const fetchBrowsePane = (pane: number): FetchBrowsePaneAction => ({type: 'fetchBrowsePane', pane});

export const successBrowsePane = (pane: number): SuccessBrowsePaneAction => ({type: 'successBrowsePane', pane});

////////////////////////////////////////////////////////////////////////////////////////////

export const resetBrowsePanes = (): ResetBrowsePanesAction => ({type: 'resetBrowsePanes'});

export const bwsTimestripIsFetching = (pane: number): BwsTimestripIsFetchingAction => ({
  type: 'browseFetchTimeStrips',
  pane
});

export const bwsEndTimestripIsFetching = (pane: number): BwsTimestripIsFetchingAction => ({
  type: 'browseEndFetchTimeStrips',
  pane
});

export const bwsAddTimeStrips = (pane: number, strips: any[] | null, continuation_id: string | null): BwsAddTimeStripsAction => ({
  type: 'browseAddTimeStrips',
  pane,
  strips,
  continuation_id
});

export const bwsTimestripError = (pane: number): BwsErrorTimeStripsAction => ({type: 'browseErrorTimeStrips', pane});

export const bwsResetTimestrips = (time: number): BwsResetTimeStripsAction => ({type: 'browseResetTimeStrips', time});

export const setDraggableCamId = (draggableCamId: CameraDataInterface | null): SetDraggableCamIdAction => ({
  type: 'setDraggableCamId',
  draggableCamId
});

export const bwsAddCameraBookmarks = (pane: number, bookmarks: IBookmarks[]): BwsAddCameraBookmarksAction => ({
  type: 'browseAddCameraBookmarks',
  pane,
  bookmarks
});
// for browse saga
// export const getBrowseFrame = (id: string, time: number, pane: number) : GetBrowseFrameAction => ({type:
// 'getBrowseFrame', id, time, pane});

// export const setBrowseFrame = (pane: number, status: string, time: number,  src?: string) : SetBrowseFrameAction => {
//     return {type: 'setBrowseFrame', pane, src, status, time}
// };


export const setSelectedBookmark = (selectedBookmark: IBookmarks): SetSelectedBookmarkAction => ({type: 'setSelectedBookmark', selectedBookmark});
